import input from "./input";

const pinInput = {
  variants: {
    outline: input.variants?.outline.field,
  },
};

export default pinInput;
